import { message, notification } from "antd";

// Every place that can show a notification popup registers how to clear it,
// so logging out removes them all at once: the static API, App.useApp()'s
// holder and the hook-based holders (chat messages, staff presence).
const dismissers = new Set();

export function registerNotificationDismisser(dismiss) {
  dismissers.add(dismiss);
  return () => dismissers.delete(dismiss);
}

export function dismissAllNotifications() {
  dismissers.forEach(dismiss => { try { dismiss(); } catch { } });
  notification.destroy();
  message.destroy();
}
